module.exports = __webpack_public_path__ + "static/img/anxun81.ef8ef904.png";